import { useFormikContext } from "formik";

function useFormikTextArea() {
  const formik = useFormikContext();
  const { setFieldValue } = formik;

  const handleChange = (name, event) => {
    formik.handleChange(event);
    // Calling helper function
    // handleChangeHelper(name, event, setFieldValue);
  };

  const handleBlur = (name, event) => {
    // Calling helper function
    // handleOnBlurHelper();
  };

  return { handleChange, handleBlur };
}

export default useFormikTextArea;
